import style from "./styles";
import PropTypes from "prop-types";

const PremierHero = ({ assetsUrl }) => (
  <div className={style.PremierHero}>
    <img
      className={style.PremierTitleImage}
      src={`${assetsUrl}/premier-landing-page/img/png/asos-premier-2.png`}
      alt="ASOS Premier"
    />
  </div>
);

PremierHero.propTypes = {
  assetsUrl: PropTypes.string,
};

export default PremierHero;
